import React from 'react';
import OutrightsOdd from '../../common/OutrightsOdd';
import { getLabel } from '../../InitData';
import { getBetDescription } from '../../data/utils';

function CompetitionOutrights(props) {
    
    return (
        <>
            <div className="titolo-filtro p-2 w-100">
                <p className="testo-grande grassetto colore-1">{getLabel('prematch_page.torneo.outrights')} - {props.descrizione}</p>
            </div>
            <div className="d-grid formato-grid-3-colonne">
                {props.outrights.sort((a, b) => a.timestampDB - b.timestampDB).map(or => {
                    return or.scommesse.map((bet, index) => {
                        const o = bet.odds.filter(o => o.value !== null);
                        const part1 = o.slice(0, 20);
                        const part2 = o.slice(20);
                        const boxUniqueId = `${or.pal}_${or.avv}_${bet.id}_${index}`;
                        let descBet = bet.desc;
                        if((bet.handicap !== 0)){
                        	descBet = getBetDescription(bet, true, or.sportRef, or.scommesse);
                        }
                        return (
                            <div key={boxUniqueId} className="outrightsCont p-3 bg-bianco bordo-tondo">
                                <a className="toggle-nascondi-live pointer allinea-sx padding-orizzontale padding-verticale bordo-tondo bg-nero bianco" data-toggle="collapse" href={`#or-part1-collapse-${boxUniqueId}`} role="button">
                                	{/*bet.desc ? `${or.desc} - ${bet.desc} ${descHandicap}` : or.desc*/}
                                	{or.desc}{ descBet? (" - " + descBet) : ''}
                                </a>
                                <div className="collapse show active bg-bianco" id={`or-part1-collapse-${boxUniqueId}`}>
                                    {part1.map((odd, i) =>
                                        <OutrightsOdd key={i} {...odd} />
                                    )}
                                    {part2.length > 0 &&
                                        <>
                                            <div className="collapse bg-bianco" id={`or-part2-collapse-${boxUniqueId}`}>
                                                {part2.map((odd, i) =>
                                                    <OutrightsOdd key={i} {...odd} />
                                                )}
                                            </div>
                                            <a className="toggle-nascondi-live pointer allinea-sx padding-orizzontale padding-verticale bordo-tondo bg-bianco nero collapsed" data-toggle="collapse" href={`#or-part2-collapse-${boxUniqueId}`} role="button">{getLabel('prematch_page.torneo.outrights.toggle_button.show_all')}</a>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    })
                })}
            </div>
        </>
    );
}

export default CompetitionOutrights;
